(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[598],{

/***/ 65525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15153);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(path__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58048);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(576);
/* harmony import */ var _tm_ui_contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85129);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27821);
/* harmony import */ var react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // import "pwa-mmt-ui-header/ssr/header.css";

 // Magic import



path__WEBPACK_IMPORTED_MODULE_1___default().resolve("./next.config.js");

function CustomApp({
  Component,
  pageProps
}) {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  (0,_tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__/* .setRouter */ .OD)(router);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("main", {
      className: "app",
      "data-test-id": "main",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_ui_contexts__WEBPACK_IMPORTED_MODULE_4__/* .PlanTypeProvider */ .p, {
        "data-test-id": "PlanTypeProvider",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_2__/* .ErrorBoundary */ .SV, {
          onError: error => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_2__/* .ErrorScreen */ .Cs, {
            error: error,
            "data-test-id": "ErrorScreen"
          }),
          "data-test-id": "ErrorBoundary",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Component, _objectSpread(_objectSpread({}, pageProps), {}, {
            "data-test-id": "Component"
          }))
        })
      })
    })
  });
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomApp);

/***/ }),

/***/ 97427:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XF": () => (/* reexport */ ClientError),
  "St": () => (/* reexport */ clientStorageUtils/* getSessionStorageItem */.St),
  "Pj": () => (/* reexport */ utils/* parsePriceToNumber */.Pj),
  "lD": () => (/* reexport */ clientStorageUtils/* removeSessionStorageItem */.lD),
  "D9": () => (/* reexport */ clientStorageUtils/* setSessionStorageItem */.D9)
});

// UNUSED EXPORTS: TRIPMONEY_MMT_DOMAIN_NAMES, disableEncrytionInWeb, getDeviceModelType, getHostName, getUtilOptions, isHostMakemytrip, loadGTM

;// CONCATENATED MODULE: ../../libs/utility/src/lib/ClientError/index.ts
class ClientError extends Error {
  constructor(message) {
    super();
    this.message = message;
  }

  getErrorMessage() {
    return this.message;
  }

}
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(37290);
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/index.ts
var utils = __webpack_require__(59055);
;// CONCATENATED MODULE: ../../libs/utility/src/index.ts




/***/ }),

/***/ 38474:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mmt_event_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81099);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);

 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore




const LoadAdobeScript = ({
  partner = "mmt"
}) => {
  const env =  false ? 0 : "production";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    "data-test-id": "LoadAdobeScript-Head",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("script", {
      src: partner === "mmt" ? (0,_mmt_event_logger__WEBPACK_IMPORTED_MODULE_2__/* .getAdobeScriptMMT */ .mZ)(env) : (0,_mmt_event_logger__WEBPACK_IMPORTED_MODULE_2__/* .getAdobeScriptGI */ .QQ)(env),
      async: true,
      "data-test-id": "LoadAdobeScript-script"
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LoadAdobeScript);

/***/ }),

/***/ 2182:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": () => (/* reexport */ getAnalytics),
  "Q": () => (/* reexport */ setLandingPageAnalytics)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/internal.ts
function injectPlatform(eventObj) {
  const isPageViewEvent = ["pageView", "errorScreen"].includes(eventObj?.event);
  const missingPlatform = eventObj?.page?.pageInfo && !eventObj?.page?.pageInfo?.platform;

  if (isPageViewEvent && missingPlatform) {
    eventObj.page.pageInfo.platform = /Mobile|Android|BlackBerry/.test(navigator.userAgent) ? "mweb" : "desktop";
  }
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/index.ts

const pushEvent = eventObj => {
  const isClientSide = typeof navigator !== "undefined" && true;
  if (!isClientSide) return;
  injectPlatform(eventObj); // @ts-ignore

  window.adobeDataLayer = window.adobeDataLayer || []; // @ts-ignore

  window.adobeDataLayer.push(eventObj);
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/constants.ts

const LOB_NAME_TM_INS = (0,utils/* isPartnerMMT */.rS)() ? "desktop tripmoney insurance" : "tripmoney insurance";
const LOB_NAME_PS_INS = (0,utils/* isPartnerMMT */.rS)() ? "desktop ps tripmoney insurance" : "ps tripmoney insurance";
const FUNNEL_SITE_SECTION = (0,utils/* isPartnerMMT */.rS)() ? "desktop tripmoney insurance Funnel" : "tripmoney insurance Funnel";
const LANDING_SITE_SECTION = "landing";
const LOB_NAME_MYPARTNER = "desktop tripmoney insurance mypartner";
const PAGE_NAMES_MAP_MMT = {
  COMMON_LANDING: "desktop:common_landing:mmt_insurance:homepage",
  COMMON_LANDING_RETAIL: "desktop:common_landing:mmt_insurance:homepage_retail",
  LANDING: "desktop:landing:mmt_insurance:homepage",
  LANDING_RETAIL: "desktop:landing:mmt_insurance:homepage_retail",
  LISTING: "desktop:funnel:mmt_insurance:listing",
  REVIEW: "desktop:funnel:mmt_insurance:review",
  PAYMENT: "desktop:funnel:mmt_insurance:payment",
  THANK_YOU_POLICY: "desktop:funnel:mmt_insurance:TY_policy",
  THANK_YOU_PASSPORT: "desktop:funnel:mmt_insurance:TY_passport",
  ADD_PASSPORT: "desktop:funnel:mmt_insurance:add_passport",
  ORDER_SUMMARY: "desktop:post_Sales:mmt_insurance:order_summary",
  ORDER_DETAILS: "desktop:post_Sales:mmt_insurance:order_details"
};
const PAGE_NAMES_MAP_GI = {
  COMMON_LANDING: "common_landing:tripmoney insurance:homepage",
  COMMON_LANDING_RETAIL: "common_landing:tripmoney insurance:homepage_retail",
  LANDING: "landing:tripmoney insurance:landing",
  LANDING_RETAIL: "landing:tripmoney insurance:homepage_retail",
  LISTING: "funnel:tripmoney insurance:listing",
  REVIEW: "funnel:tripmoney insurance:review",
  PAYMENT: "funnel:tripmoney insurance:payment",
  THANK_YOU_POLICY: "funnel:tripmoney insurance:thankyoupolicy",
  THANK_YOU_PASSPORT: "funnel:tripmoney insurance:thankyoupassport",
  ADD_PASSPORT: "funnel:tripmoney insurance:addpassport",
  ORDER_SUMMARY: "post sales:ps_tripmoney insurance:order_summary",
  ORDER_DETAILS: "post sales:ps_tripmoney insurance:order_details"
};
const PAGE_NAMES_MAP = (0,utils/* isPartnerMMT */.rS)() || (0,utils/* isMyPartner */.bR)() || (0,utils/* isMyBiz */.xA)() ? PAGE_NAMES_MAP_MMT : PAGE_NAMES_MAP_GI;
const pageNameCategoryMap = {
  COMMON_LANDING: {
    pageName: PAGE_NAMES_MAP["COMMON_LANDING"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION
  },
  COMMON_LANDING_RETAIL: {
    pageName: PAGE_NAMES_MAP["COMMON_LANDING_RETAIL"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION
  },
  LANDING: {
    pageName: PAGE_NAMES_MAP["LANDING"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION
  },
  LANDING_RETAIL: {
    pageName: PAGE_NAMES_MAP["LANDING_RETAIL"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION
  },
  LISTING: {
    pageName: PAGE_NAMES_MAP["LISTING"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  REVIEW: {
    pageName: PAGE_NAMES_MAP["REVIEW"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  PAYMENT: {
    pageName: PAGE_NAMES_MAP["PAYMENT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  THANK_YOU_POLICY: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_POLICY"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  THANK_YOU_PASSPORT: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  ADD_PASSPORT: {
    pageName: PAGE_NAMES_MAP["ADD_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  ORDER_DETAILS: {
    pageName: PAGE_NAMES_MAP["ORDER_DETAILS"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA"
  },
  ORDER_SUMMARY: {
    pageName: PAGE_NAMES_MAP["ORDER_SUMMARY"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA"
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/GIAnalytics.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function flushGIAnalyticsQueue() {
  if ( true && window.giAnalyticsQueue && typeof pushEvent === "function") {
    window.giAnalyticsQueue.forEach(event => {
      pushEvent(event);
    });
    window.giAnalyticsQueue = [];
  }
}

if ((0,utils/* isPartnerGI */.Pk)() && true) {
  window.addEventListener("gi-analytics:ready", flushGIAnalyticsQueue);
}

function safePushEvent(event) {
  if ( false || typeof pushEvent !== "function") {
    if (true) {
      window.giAnalyticsQueue = window.giAnalyticsQueue || [];
      window.giAnalyticsQueue.push(event);
    } // If window is undefined (SSR), do nothing


    return;
  }

  pushEvent(event);
}

class GIAnalytics {
  trackPageLoadEvent(event, type) {
    const {
      pageName,
      lob,
      siteSection
    } = pageNameCategoryMap[event?.pageName];
    const authCookie = (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");

    let omniData = _objectSpread(_objectSpread({
      event: "pageView",
      page: {
        pageInfo: _objectSpread({
          pageName,
          lob,
          section: siteSection
        }, event.experiment && {
          abVariant: event.experiment
        })
      },
      booking: _objectSpread(_objectSpread({}, event.bookingId && {
        bookingId: event.bookingId
      }), event.bookingStatus && {
        paymentStatus: event.bookingStatus
      })
    }, authCookie && {
      authStatus: "Login"
    }), !authCookie && {
      authStatus: "Guest"
    });

    if (event.pageName === "LISTING") {
      omniData = _objectSpread(_objectSpread({}, omniData), {}, {
        event: "tm_ins_listing_view",
        booking: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, event.country && {
          routeCity: event.country
        }), event.startDate && {
          departureDate: event.startDate
        }), event.endDate && {
          returnDate: event.endDate
        }), event.purpose && {
          purposeOfTravel: event.purpose
        }), event.travellers && {
          pax: event.travellers
        })
      });
    }

    safePushEvent(omniData);
  }

  trackRawPageLoadEvent(event, type) {
    const omniData = {
      event: "pageView",
      page: {
        pageInfo: {
          pageName: event?.eVar15
        }
      }
    };
    safePushEvent(omniData);
  }

  trackPageLoadErrorEvent(event, type) {
    const {
      pageName
    } = pageNameCategoryMap[event?.pageName];
    const omniData = {
      event: "pageView",
      page: {
        pageInfo: {
          pageName
        }
      },
      cta: {
        name: event.actionType
      },
      error: event.error
    };
    safePushEvent(omniData);
  }

  trackCommonLandingEvents(event, eventType = "pageView") {//Track when this comes in GI
  }

  trackLandingEvents(event, eventType = "pageView", type) {
    const {
      pageName,
      lob
    } = pageNameCategoryMap.LANDING;
    let omniData;

    if (eventType === "pageView") {
      omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    } else {
      omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    }

    if (event.actionType === "other_countries_clicked" || event.actionType === "popular_country_selected" || event.actionType === "searched_countries" || event.actionType === "selected_countries") {
      omniData = _objectSpread(_objectSpread({}, omniData), {}, {
        booking: {
          routeCity: event.payload
        }
      });
    } else if (event.actionType === "travel_date_selected") {
      omniData = _objectSpread(_objectSpread({}, omniData), {}, {
        booking: {
          departureDate: event.payload.departure,
          returnDate: event.payload.arrival
        }
      });
    } else if (event.actionType === "error_shown") {
      omniData = _objectSpread(_objectSpread({}, omniData), {}, {
        error: event.payload
      });
    }

    safePushEvent(omniData);
  }

  trackListingEvents(event, eventType = "pageView", type) {
    const {
      pageName,
      lob
    } = pageNameCategoryMap.LISTING;
    let omniData;

    if (eventType === "pageView") {
      omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    } else {
      omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    }

    if (event.actionType === "sum_insured_selected") {
      omniData = _objectSpread(_objectSpread({}, omniData), {}, {
        booking: {
          sumInsuredValue: event.payload
        }
      });
    }

    safePushEvent(omniData);
  }

  trackTravDetailsEvents(event, eventType = "pageView", type) {
    const {
      pageName,
      lob
    } = pageNameCategoryMap.REVIEW;
    let omniData;

    if (eventType === "pageView") {
      omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    } else {
      omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    }

    if (event.actionType === "error_shown") {
      omniData = _objectSpread(_objectSpread({}, omniData), {}, {
        error: event.payload
      });
    }

    safePushEvent(omniData);
  }

  trackThankYouEvents(event, eventType = "pageView", type) {
    const {
      pageName,
      lob
    } = pageNameCategoryMap[event.pageName];
    let omniData;

    if (eventType === "pageView") {
      omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    } else {
      omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    }

    safePushEvent(omniData);
  }

  trackAddPassportEvents(event, eventType = "pageView") {
    const {
      pageName,
      lob
    } = pageNameCategoryMap.ADD_PASSPORT;
    let omniData;

    if (eventType === "pageView") {
      omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    } else {
      omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    }

    safePushEvent(omniData);
  }

  trackOrderSummaryEvents(event, eventType = "pageView") {
    const {
      pageName,
      lob
    } = pageNameCategoryMap.ORDER_SUMMARY;
    let omniData;

    if (eventType === "pageView") {
      omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    } else {
      omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    }

    safePushEvent(omniData);
  }

  trackOrderDetailsEvents(event, eventType = "pageView") {
    const {
      pageName,
      lob
    } = pageNameCategoryMap.ORDER_DETAILS;
    let omniData;

    if (eventType === "pageView") {
      omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    } else {
      omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName,
            lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
    }

    safePushEvent(omniData);
  }

}
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 1 modules
var src = __webpack_require__(97427);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/IAnalytics.ts
let landingPageAnalytics;
const setLandingPageAnalytics = analytics => {
  landingPageAnalytics = analytics;
};
const getLandingPageAnalytics = () => landingPageAnalytics;
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/MmtAnalytics.ts


function MmtAnalytics_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MmtAnalytics_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MmtAnalytics_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MmtAnalytics_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const omnitureMap = {
  pageName: "eVar15",
  lob: "eVar24",
  siteSection: "m_ch",
  destination: "eVar31",
  ctaAction: "prop52",
  departureDate: "prop4",
  arrivalDate: "prop5",
  noOftravellers: "eVar8",
  travelPurpose: "eVar12",
  sumInsured: "prop46",
  bookingId: "eVar16",
  bookingStatus: "eVar14",
  errorCode: "eVar22",
  cmp: "m_v81",
  experiment: "eVar120",
  modalLoaded: "prop54",
  authStatus: "eVar39",
  userId: "eVar20"
};
class MmtAnalytics {
  trackEvent(pageName, omniData) {
    if (true) {
      omniData = MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({}, omniData), {}, {
        pageName
      });

      if (window.omniscriptLoaded) {
        if (typeof window.s !== "undefined") {
          for (const [key, value] of Object.entries(omniData)) {
            window.s[key] = value;
          }

          window.s?.t?.();
        }
      } else {
        window.omnidata?.push?.(omniData);
      }
    }
  }

  trackInteractionEvent(eventData, type) {
    if (false) {}
    let variableOverrides = {};

    for (const [key, value] of Object.entries(eventData)) {
      variableOverrides[key] = value;
      variableOverrides.linkTrackVars = key;
    }

    if (type && variableOverrides.pageName) {
      variableOverrides.pageName = `${variableOverrides.pageName}_${type}`;
    } // If s is available, fire immediately


    if (window.s && typeof window.s.tl === "function") {
      window.s.tl(true, "o", "ctaAction", variableOverrides);
    } else {
      // Otherwise, queue the event
      window.omniInteractionQueue = window.omniInteractionQueue || [];
      window.omniInteractionQueue.push(variableOverrides);
    }
  }

  trackPageLoadEvent(event, type) {
    let {
      pageName,
      lob,
      siteSection
    } = pageNameCategoryMap[event?.pageName];
    if (type) pageName = `${pageName}_${type}`;
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth");
    const userInfo = (0,src/* getSessionStorageItem */.St)("userInfo", true, // isEssential = true (equivalent to itemType.ES)
    {
      isPiiData: true,
      shouldParseJson: true
    });

    let omniData = MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["siteSection"]]: siteSection
    }, event?.bookingId && {
      [omnitureMap["bookingId"]]: event.bookingId
    }), event?.bookingStatus && {
      [omnitureMap["bookingStatus"]]: event.bookingStatus
    }), event?.experiment && {
      [omnitureMap["experiment"]]: event.experiment
    }), authCookie && {
      [omnitureMap["authStatus"]]: "Login"
    }), !authCookie && {
      [omnitureMap["authStatus"]]: "Guest"
    }), userInfo && userInfo?.uuid && {
      [omnitureMap["userId"]]: userInfo.uuid
    });

    if (event.pageName === "LISTING") {
      omniData = MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({}, omniData), event.country && {
        [omnitureMap["destination"]]: event.country
      }), event.startDate && {
        [omnitureMap["departureDate"]]: event.startDate
      }), event.endDate && {
        [omnitureMap["arrivalDate"]]: event.endDate
      }), event.purpose && {
        [omnitureMap["travelPurpose"]]: event.purpose
      }), event.travellers && {
        [omnitureMap["noOftravellers"]]: event.travellers
      });
    }

    this.trackEvent(`${pageName}${partnerSuffix}`, MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({}, omniData), event?.bookingId && {
      purchaseID: event.bookingId
    }));
  }

  trackRawPageLoadEvent(event, type) {
    if (event?.eVar15) {
      let pageName = event.eVar15;
      if (type) pageName = `${pageName}_${type}`;
      this.trackEvent(pageName, event);
    }
  }

  trackPageLoadErrorEvent(event, type) {
    let {
      pageName
    } = pageNameCategoryMap[event?.pageName];
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    if (type) pageName = `${pageName}_${type}`;
    const omniData = {
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["ctaAction"]]: event.actionType,
      [omnitureMap["errorCode"]]: event.error
    };
    this.trackEvent(pageName, omniData);
  }

  trackCommonLandingEvents(event, eventType = "pageView", type) {
    let {
      pageName,
      lob
    } = pageNameCategoryMap.COMMON_LANDING;
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const params = new URLSearchParams(window.location.search);
    const isRetail = params.get("isRetail") === "true";

    if (isRetail) {
      pageName = pageNameCategoryMap.COMMON_LANDING_RETAIL.pageName;
    } else {
      pageName = pageNameCategoryMap.COMMON_LANDING.pageName;
    }

    if (type) pageName = `${pageName}_${type}`;
    const omniData = {
      [omnitureMap["pageName"]]: pageName,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["ctaAction"]]: event.actionType
    };
    /* istanbul ignore if */

    if (event.actionType === "error_shown") {
      omniData[omnitureMap["errorCode"]] = event.payload;
    }

    if (eventType === "pageView") {
      this.trackEvent(pageName, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

  trackLandingEvents(event, eventType = "pageView", type) {
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    const landingPageAnalytics = getLandingPageAnalytics();
    let pageName, omniData;

    if (landingPageAnalytics) {
      omniData = MmtAnalytics_objectSpread(MmtAnalytics_objectSpread({}, landingPageAnalytics), {}, {
        [omnitureMap["ctaAction"]]: event.actionType
      });
      pageName = omniData.eVar15;
    } else {
      pageName = pageNameCategoryMap[`LANDING`].pageName;
      let lob = pageNameCategoryMap[`LANDING`].lob;
      lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
      omniData = {
        [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
        [omnitureMap["lob"]]: lob,
        [omnitureMap["ctaAction"]]: event.actionType
      };
    }

    if (type) pageName = `${pageName}_${type}${partnerSuffix}`;

    if (event.actionType === "other_countries_clicked" || event.actionType === "popular_country_selected" || event.actionType === "searched_countries" || event.actionType === "selected_countries") {
      omniData[omnitureMap["destination"]] = event.payload;
    } else if (event.actionType === "travel_date_selected") {
      omniData[omnitureMap["departureDate"]] = event.payload.departure;
      omniData[omnitureMap["arrivalDate"]] = event.payload.arrival;
    } else if (event.actionType === "error_shown") {
      omniData[omnitureMap["errorCode"]] = event.payload;
    }

    if (eventType === "pageView") {
      this.trackEvent(`${pageName}${partnerSuffix}`, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

  trackListingEvents(event, eventType = "pageView", type) {
    let {
      pageName,
      lob
    } = pageNameCategoryMap.LISTING;
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    if (type) pageName = `${pageName}_${type}`;
    const omniData = {
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["ctaAction"]]: event.actionType
    };
    /* istanbul ignore if */

    if (event.actionType === "error_shown") {
      omniData[omnitureMap["errorCode"]] = event.payload;
    } else if (event.actionType === "sum_insured_selected") {
      omniData[omnitureMap["sumInsured"]] = event.payload;
    }

    if (eventType === "pageView") {
      this.trackEvent(`${pageName}${partnerSuffix}`, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

  trackTravDetailsEvents(event, eventType = "pageView", type) {
    let {
      pageName,
      lob
    } = pageNameCategoryMap.REVIEW;
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    if (type) pageName = `${pageName}_${type}`;
    const omniData = {
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["ctaAction"]]: event.actionType
    };

    if (event.actionType === "error_shown") {
      omniData[omnitureMap["errorCode"]] = event.payload;
    }

    if (eventType === "pageView") {
      this.trackEvent(`${pageName}${partnerSuffix}`, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

  trackThankYouEvents(event, eventType = "pageView", type) {
    let {
      pageName,
      lob
    } = pageNameCategoryMap[event.pageName];
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    if (type) pageName = `${pageName}_${type}`;
    const omniData = {
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["ctaAction"]]: event.actionType
    };

    if (eventType === "pageView") {
      this.trackEvent(`${pageName}${partnerSuffix}`, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

  trackAddPassportEvents(event, eventType = "pageView") {
    let {
      pageName,
      lob
    } = pageNameCategoryMap.ADD_PASSPORT;
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    const omniData = {
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["ctaAction"]]: event.actionType
    };

    if (eventType === "pageView") {
      this.trackEvent(`${pageName}${partnerSuffix}`, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

  trackOrderSummaryEvents(event, eventType = "pageView") {
    let {
      pageName,
      lob
    } = pageNameCategoryMap.ORDER_SUMMARY;
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    const omniData = {
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["pageName"]]: pageName,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["ctaAction"]]: event.actionType
    };

    if (eventType === "pageView") {
      this.trackEvent(`${pageName}${partnerSuffix}`, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

  trackOrderDetailsEvents(event, eventType = "pageView") {
    let {
      pageName,
      lob
    } = pageNameCategoryMap.ORDER_DETAILS;
    lob = (0,utils/* isMyPartner */.bR)() ? LOB_NAME_MYPARTNER : lob;
    const partnerSuffix = (0,utils/* isMyBiz */.xA)() ? "|corporate" : (0,utils/* isMyPartner */.bR)() ? "|mypartner" : "";
    const omniData = {
      [omnitureMap["pageName"]]: `${pageName}${partnerSuffix}`,
      [omnitureMap["lob"]]: lob,
      [omnitureMap["ctaAction"]]: event.actionType
    };

    if (eventType === "pageView") {
      this.trackEvent(`${pageName}${partnerSuffix}`, omniData);
    } else {
      this.trackInteractionEvent(omniData);
    }
  }

} // Helper to flush the interaction queue when window.s is ready

function flushOmniInteractionQueue() {
  if ( true && window.omniInteractionQueue && window.s && typeof window.s.tl === "function") {
    window.omniInteractionQueue.forEach(event => {
      window.s.tl(true, "o", "ctaAction", event);
    });
    window.omniInteractionQueue = [];
  }
} // Listen for a custom event that should be dispatched when analytics script is loaded


if ((0,utils/* isPartnerMMT */.rS)() && true) {
  window.addEventListener("mmt-omniture:ready", flushOmniInteractionQueue);
} // NOTE: The analytics script should dispatch this event when ready:
// window.dispatchEvent(new Event("omniture:ready"));
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/analyticsWrapper.ts



let analytics = null;
function getAnalytics() {
  if (analytics === null && ((0,utils/* isPartnerMMT */.rS)() || (0,utils/* isMyPartner */.bR)() || (0,utils/* isMyBiz */.xA)())) {
    analytics = new MmtAnalytics();
  } else if (analytics === null && (0,utils/* isPartnerGI */.Pk)()) {
    analytics = new GIAnalytics();
  }

  return analytics;
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts



/***/ }),

/***/ 66857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": () => (/* binding */ createAnalyticsEvent),
/* harmony export */   "E5": () => (/* binding */ getCachedPageData),
/* harmony export */   "EQ": () => (/* binding */ setupPageExitListeners),
/* harmony export */   "Lk": () => (/* binding */ getPageNameAnalytics),
/* harmony export */   "Nm": () => (/* binding */ getMergedSearchContext),
/* harmony export */   "R5": () => (/* binding */ handlePageExit),
/* harmony export */   "ag": () => (/* binding */ getAdobeAnalytics),
/* harmony export */   "po": () => (/* binding */ trackComponentView),
/* harmony export */   "qQ": () => (/* binding */ setCachedPageData),
/* harmony export */   "u8": () => (/* binding */ getSelectedCountriesFromLocalStorage)
/* harmony export */ });
/* unused harmony exports getSearchContext, generateErrorDetailsListL1, clearPageTracking, getCachedSearchContext, getComponentViewsAndClear */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62663);
/* harmony import */ var _xdmEvents__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46535);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // Hardcoded constants as per requirements

const HARDCODED_DATA = {
  event_tracking_context: {
    template_id: 52319,
    funnel_source: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPartnerGI */ .Pk)() ? "gi" : "mmt",
    bu: "tripmoney",
    org: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPartnerGI */ .Pk)() ? "gi" : "mmt",
    env: "qa",
    topic_name: "mmt_insurance_b2c_pdt_client_logging_v2",
    organisation: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPartnerGI */ .Pk)() ? "GI" : "MMT",
    funnel_entry: "direct"
  },
  page_context: {
    lob: "travelinsurance",
    lob_category: "travelinsurance",
    page_url:  true ? window.location.href : 0,
    page_title: typeof document !== "undefined" ? document.title : ""
  }
}; // Memory storage for cached page data

let cachedPageData = null;
let pageExitListenersAdded = false;
let exitEventTriggered = {
  default: false
}; // Memory storage for cached search context data

let cachedSearchContext = null; // Memory storage for component view tracking

let componentViews = [];
/**
 * Remove empty keys from an object
 */

const removeEmptyKeys = obj => {
  const result = {};

  for (const key in obj) {
    const value = obj[key]; // Check if value is not empty (not null, undefined, empty string, empty array, or empty object)

    if (value !== null && value !== undefined && value !== "" && !(Array.isArray(value) && value.length === 0) && !(typeof value === "object" && Object.keys(value).length === 0)) {
      // If it's an object (but not array), recursively clean it
      if (typeof value === "object" && !Array.isArray(value)) {
        const cleanedValue = removeEmptyKeys(value); // Only add if the cleaned object is not empty

        if (Object.keys(cleanedValue).length > 0) {
          result[key] = cleanedValue;
        }
      } else {
        result[key] = value;
      }
    }
  }

  return result;
};
/**
 * Deep merge objects with priority to the second object
 */


const deepMerge = (target, source) => {
  const result = _objectSpread({}, target);

  for (const key in source) {
    if (source[key] !== null && source[key] !== undefined) {
      if (typeof source[key] === "object" && !Array.isArray(source[key]) && typeof target[key] === "object" && !Array.isArray(target[key])) {
        result[key] = deepMerge(target[key] || {}, source[key]);
      } else {
        result[key] = source[key];
      }
    }
  }

  return result;
};
/**
 * Merge search context parameters with cached data
 * Only updates the provided keys, keeps existing values for others
 */


const mergeSearchContext = newSearchContext => {
  if (!cachedSearchContext) {
    // If no cached data, use the new data as is
    cachedSearchContext = _objectSpread({}, newSearchContext);
    return cachedSearchContext;
  } // Merge new data with cached data, new data takes priority


  cachedSearchContext = _objectSpread(_objectSpread({}, cachedSearchContext), newSearchContext);
  return cachedSearchContext;
};

const getSearchContext = searchContext => {
  if (!searchContext) {
    return {};
  }

  const routeDetails = searchContext?.countries && Array.isArray(searchContext.countries) && searchContext.countries.length > 0 ? searchContext.countries.map(country => ({
    to: _objectSpread({
      location: {
        country_code: country.code,
        name: country.name
      }
    }, country?.locusId && country?.locusType && {
      locus: {
        locus_id: country?.locusId,
        locus_type: country?.locusType
      }
    })
  })) : [];
  let toDetails = null;
  searchContext?.countries && Array.isArray(searchContext.countries) && searchContext.countries.length === 1 ? searchContext.countries.forEach(country => {
    toDetails = {
      to: _objectSpread({
        location: {
          country_code: country?.code,
          name: country?.name
        }
      }, country?.locusId && country?.locusType && {
        locus: {
          country: country?.name,
          locus_id: country?.locusId,
          locus_type: country?.locusType
        }
      })
    };
  }) : null;

  const searchContextData = _objectSpread(_objectSpread(_objectSpread({}, toDetails || {}), {}, {
    from_date_time: searchContext?.fromDateTime ? Number(searchContext.fromDateTime) * 1000 : 0,
    to_date_time: searchContext?.toDateTime ? Number(searchContext.toDateTime) * 1000 : 0,
    pax: {
      count: searchContext?.travellers ?? 0
    }
  }, routeDetails.length > 0 && {
    route_details: routeDetails ?? []
  }), searchContext?.journeyType && {
    journey_type: searchContext?.journeyType
  });

  return removeEmptyKeys(searchContextData);
};
/**
 * Utility function to handle search context merging logic
 * Returns the merged search context or null if no context is available
 */

const getMergedSearchContext = searchContext => {
  let searchContextData;

  if (searchContext) {
    searchContextData = mergeSearchContext(searchContext);
  } else if (cachedSearchContext) {
    // Use cached search context if no new one provided
    searchContextData = cachedSearchContext;
  }

  searchContextData = getSearchContext(searchContextData);
  return searchContextData;
};
const getSelectedCountriesFromLocalStorage = countryCods => {
  const countries = localStorage.getItem("TRAVEL_INSURANCE_COUNTRIES");

  if (countries) {
    const getCountries = JSON.parse(countries);
    return getCountries.filter(country => countryCods.includes(country.code));
  }

  return [];
};
/**
 * Generates components_l1 string from components array
 * @param components Array of component objects with id, position, name, and type
 * @returns Formatted components_l1 string or empty string if no components
 */

const generateComponentsL1 = components => {
  if (!components || !Array.isArray(components) || components.length === 0) {
    return "";
  }

  return components.filter(component => component.id && component.position && component.type).map(component => {
    const {
      id,
      position,
      type
    } = component;
    const v = position.v || 0;
    const h = position.h || 0; // Default to 0 if h is not provided

    return `${id}:${type}:V_${v}:H_${h}`;
  }).join("|");
};
/**
 * Generates multicity destination location name from route details
 * @param routeDetails Array of route detail objects with to.location.name
 * @returns Formatted destination location names separated by colons or empty string if no routes
 */


const generateMulticityDestinationLocationName = routeDetails => {
  if (!routeDetails || !Array.isArray(routeDetails) || routeDetails.length === 0) {
    return "";
  }

  return routeDetails.filter(route => route?.to?.location?.name).map(route => route.to.location.name).join(":");
};
/**
 * Creates the final analytics event object by merging all data layers
 */


const createAnalyticsEvent = (pageData, eventData) => {
  // Start with hardcoded data as base
  let mergedData = deepMerge({}, HARDCODED_DATA); // Merge with cached page data

  mergedData = deepMerge(mergedData, pageData); // Merge with event-specific data (highest priority)

  if (eventData) {
    mergedData = deepMerge(mergedData, eventData);
  } // Remove empty keys from the final object


  const cleanedData = removeEmptyKeys(mergedData);
  return cleanedData;
};
/**
 * Handles page exit events
 */

const handlePageExit = () => {
  // Prevent duplicate exit events
  if (exitEventTriggered[cachedPageData?.page_context?.page_name || "default"]) {
    return;
  }

  const mergedSearchContext = getMergedSearchContext();
  const componentViews = getComponentViewsAndClear();
  const adobeAnalytics = getAdobeAnalytics(mergedSearchContext, componentViews?.components);

  if (cachedPageData) {
    const exitEvent = createAnalyticsEvent(cachedPageData, _objectSpread(_objectSpread({
      event_detail: _objectSpread(_objectSpread({}, componentViews?.components && componentViews.components.length > 0 && {
        components: {
          content_details: componentViews.components
        }
      }), {}, {
        event_type: "action",
        event_name: "page-exit"
      })
    }, mergedSearchContext && {
      search_context: mergedSearchContext
    }), {}, {
      adobe_analytics: adobeAnalytics
    }));
    (0,_xdmEvents__WEBPACK_IMPORTED_MODULE_2__/* .pushToSdkEvent */ .UG)(exitEvent); // Mark exit event as triggered to prevent duplicates

    exitEventTriggered[cachedPageData?.page_context?.page_name || "default"] = true;
  } else {
    console.warn("Page exit event triggered but no cached page data available");
  }
};
const generateErrorDetailsListL1 = errorDetailsList => {
  if (!errorDetailsList || !Array.isArray(errorDetailsList) || errorDetailsList.length === 0) {
    return "";
  }

  return errorDetailsList.map(error => `${error?.code ? `${error?.code}:` : ""}${error?.message ? `${error?.message}` : ""}`).join("|");
};
const getAdobeAnalytics = (searchContext, components, errorDetailsList) => {
  const componentsL1 = generateComponentsL1(components);
  const multicityDestinationLocationName = generateMulticityDestinationLocationName(searchContext?.route_details);
  const errorDetailsListL1 = generateErrorDetailsListL1(errorDetailsList);
  return _objectSpread(_objectSpread(_objectSpread({}, multicityDestinationLocationName && {
    multicity_destination_location_name_c51: multicityDestinationLocationName
  }), componentsL1 && {
    components_l1: componentsL1
  }), errorDetailsListL1 && {
    error_details_v11: errorDetailsListL1
  });
};
/**
 * Sets up page exit event listeners automatically
 */

const setupPageExitListeners = () => {
  if (!pageExitListenersAdded && true) {
    // beforeunload - fires when the page is about to be unloaded
    window.addEventListener("beforeunload", handlePageExit); // pagehide - fires when the page is hidden (better for mobile)

    window.addEventListener("pagehide", handlePageExit); // visibilitychange - fires when the page becomes hidden (good for tab switching)

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        handlePageExit();
      }
    });
    pageExitListenersAdded = true;
  }
}; // Note: Exit listeners will be set up when initializePageTracking is called

/**
 * Removes page exit event listeners (for cleanup)
 */

const removePageExitListeners = () => {
  if (pageExitListenersAdded && true) {
    window.removeEventListener("beforeunload", handlePageExit);
    window.removeEventListener("pagehide", handlePageExit);
    document.removeEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        handlePageExit();
      }
    });
    pageExitListenersAdded = false;
  }
};
/**
 * Clear cached page data and remove event listeners (for cleanup)
 */


const clearPageTracking = () => {
  cachedPageData = null;
  exitEventTriggered = {
    default: false
  };
  cachedSearchContext = null;
  removePageExitListeners();
};
/**
 * Get current cached page data (for debugging/testing)
 */

const getCachedPageData = () => {
  return cachedPageData;
};
/**
 * Cache page data for current session
 */

const setCachedPageData = pageData => {
  cachedPageData = pageData;
};
/**
 * Get current cached search context data (for debugging/testing)
 */

const getCachedSearchContext = () => {
  return cachedSearchContext;
};
/**
 * Track a component view
 */

const trackComponentView = input => {
  const existingIndex = componentViews.findIndex(component => component.name === input.name && component.type === input.type);

  if (existingIndex !== -1) {
    // Update existing component view frequency
    componentViews[existingIndex].view_frequency += 1;
  } else {
    // Create new component view entry
    const componentData = {
      id: generateComponentId(),
      name: input.name,
      type: input.type,
      tracking_key: input.tracking_key,
      card_component: input.card_component,
      view_frequency: 1,
      position: {
        v: componentViews.length + 1
      }
    };
    const cleanedData = removeEmptyKeys(componentData);
    const newComponent = cleanedData;
    componentViews.push(newComponent);
  }
};
/**
 * Get all tracked component views and clear cache
 */

const getComponentViewsAndClear = () => {
  const result = {
    components: [...componentViews],
    totalComponents: componentViews.length,
    totalViews: componentViews.reduce((sum, component) => sum + component.view_frequency, 0),
    retrievedAt: Date.now()
  }; // Clear the cached data

  componentViews = [];
  return result;
};
/**
 * Generate unique component ID
 */

const generateComponentId = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

//Expected 'landing' | 'listing' | 'detail' | 'review' | 'payment' | 'thankyou',
const getPageNameAnalytics = pageName => {
  switch (pageName) {
    case "LANDING":
      return "landing";

    case "LANDING_RETAIL":
      return "landing_retail";

    case "LANDING_MYPARTNER":
      return "landing_mypartner";

    case "LISTING":
      return "listing";

    case "REVIEW":
      return "review";

    case "PAYMENT":
      return "payment";

    case "THANK_YOU_POLICY":
      return "thankyou";

    case "THANK_YOU_PASSPORT":
      return "thankyou";

    case "ADD_PASSPORT":
      return "thankyou";

    case "ORDER_SUMMARY":
      return "detail";

    case "ORDER_DETAILS":
      return "detail";

    case "COMMON_LANDING":
      return "landing";

    case "COMMON_LANDING_RETAIL":
      return "landing";

    case "LISTING_MYPARTNER":
      return "listing";

    case "REVIEW_MYPARTNER":
      return "review";

    case "THANK_YOU_POLICY_MYPARTNER":
      return "thankyou";

    case "PAYMENT_MYPARTNER":
      return "payment";

    default:
      return "landing";
  }
};

/***/ }),

/***/ 50354:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getPageNameAnalytics": () => (/* reexport safe */ _analyticsUtils__WEBPACK_IMPORTED_MODULE_0__.Lk),
/* harmony export */   "getSelectedCountriesFromLocalStorage": () => (/* reexport safe */ _analyticsUtils__WEBPACK_IMPORTED_MODULE_0__.u8),
/* harmony export */   "initializeErrorPageTracking": () => (/* reexport safe */ _xdmEvents__WEBPACK_IMPORTED_MODULE_2__.nD),
/* harmony export */   "initializePageTracking": () => (/* reexport safe */ _xdmEvents__WEBPACK_IMPORTED_MODULE_2__.L7),
/* harmony export */   "trackComponentView": () => (/* reexport safe */ _xdmEvents__WEBPACK_IMPORTED_MODULE_2__.po),
/* harmony export */   "trackEvent": () => (/* reexport safe */ _xdmEvents__WEBPACK_IMPORTED_MODULE_2__.L9),
/* harmony export */   "triggerPageExit": () => (/* reexport safe */ _xdmEvents__WEBPACK_IMPORTED_MODULE_2__.Te),
/* harmony export */   "updateSearchContext": () => (/* reexport safe */ _xdmEvents__WEBPACK_IMPORTED_MODULE_2__.KW)
/* harmony export */ });
/* harmony import */ var _analyticsUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66857);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62516);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _xdmEvents__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46535);
// Export analytics utilities
 // Export types




/***/ }),

/***/ 62516:
/***/ (() => {



/***/ }),

/***/ 46535:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t1": () => (/* binding */ errorTrackEvent),
  "nD": () => (/* binding */ initializeErrorPageTracking),
  "L7": () => (/* binding */ initializePageTracking),
  "UG": () => (/* binding */ pushToSdkEvent),
  "po": () => (/* binding */ trackComponentView),
  "L9": () => (/* binding */ trackEvent),
  "Te": () => (/* binding */ triggerPageExit),
  "KW": () => (/* binding */ updateSearchContext)
});

// UNUSED EXPORTS: getComponentViewsAndClear

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/analyticsUtils.ts
var analyticsUtils = __webpack_require__(66857);
// EXTERNAL MODULE: ../../node_modules/@mmt/event-logger/dist/index.mjs
var dist = __webpack_require__(81099);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/initLogger.ts
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore


const AnalyticsSdk = (0,dist/* initAndGetAnalyticsSdk */.Xy)({
  org: (0,utils/* isPartnerGI */.Pk)() ? "GI" : "MMT"
});
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




/**
 * Push event to Adobe Data Layer
 * @param eventObj Event object to push
 */
const pushToSdkEvent = eventObj => {
  try {
    const extraOptions = {
      lob: "travelinsurance",
      destinationUrl: window.location.href
    };
    AnalyticsSdk.pushToAdobeDataLayer(eventObj, extraOptions);
  } catch (error) {
    console.error("Error pushing event to Adobe Data Layer", error);
  }
};
/**
 * Initialize page tracking - call during React component mount
 * Caches page-level data and triggers automatic 'page-render' event
 */

const initializePageTracking = (pageData, searchContext) => {
  // Store page data in memory for current session
  (0,analyticsUtils/* setCachedPageData */.qQ)(pageData); // Use the imported functions from analyticsUtils

  let mergedSearchContext = (0,analyticsUtils/* getMergedSearchContext */.Nm)(searchContext);

  if (searchContext?.isReadStoreSearchContext) {
    mergedSearchContext = JSON.parse(sessionStorage.getItem("STORE_SEARCH_CONTEXT") || "{}");
  }

  const adobeAnalytics = (0,analyticsUtils/* getAdobeAnalytics */.ag)(mergedSearchContext, pageData.event_detail?.components?.content_details || []); // Set up page exit listeners now that we have cached data

  (0,analyticsUtils/* setupPageExitListeners */.EQ)();

  if (searchContext?.isStoreSearchContext) {
    sessionStorage.setItem("STORE_SEARCH_CONTEXT", JSON.stringify(mergedSearchContext));
  } // Automatically trigger 'page-render' event


  const pageRenderEvent = (0,analyticsUtils/* createAnalyticsEvent */.E2)(pageData, {
    event_detail: {
      event_value: "page_load",
      event_name: "page-rendered",
      event_type: "page"
    },
    search_context: mergedSearchContext,
    adobe_analytics: adobeAnalytics
  });
  pushToSdkEvent(pageRenderEvent);
};
/**
 * Initialize page tracking - call during React component mount
 * Caches page-level data and triggers automatic 'page-render' event
 */

const initializeErrorPageTracking = (pageData, searchContext) => {
  // Store page data in memory for current session
  (0,analyticsUtils/* setCachedPageData */.qQ)(pageData); // Use the imported functions from analyticsUtils

  let mergedSearchContext = (0,analyticsUtils/* getMergedSearchContext */.Nm)(searchContext);

  if (searchContext?.isReadStoreSearchContext) {
    mergedSearchContext = JSON.parse(sessionStorage.getItem("STORE_SEARCH_CONTEXT") || "{}");
  }

  const adobeAnalytics = (0,analyticsUtils/* getAdobeAnalytics */.ag)(mergedSearchContext, pageData.event_detail?.components?.content_details || [], pageData.error_details_list || []); // Set up page exit listeners now that we have cached data

  (0,analyticsUtils/* setupPageExitListeners */.EQ)();

  if (searchContext?.isStoreSearchContext) {
    sessionStorage.setItem("STORE_SEARCH_CONTEXT", JSON.stringify(mergedSearchContext));
  } // Automatically trigger 'page-render' event


  const pageRenderEvent = (0,analyticsUtils/* createAnalyticsEvent */.E2)(pageData, {
    event_detail: {
      event_value: "error",
      event_name: "error",
      event_type: "action"
    },
    search_context: mergedSearchContext,
    adobe_analytics: adobeAnalytics
  });
  pushToSdkEvent(pageRenderEvent);
};
/**
 * Track manual events - call on-demand for user interactions
 * Merges event-specific data with cached page data and search context
 */

const trackEvent = (eventData, searchContext) => {
  const cachedPageData = (0,analyticsUtils/* getCachedPageData */.E5)();

  if (!cachedPageData) {
    console.warn("Page tracking not initialized. Call initializePageTracking first.");
    return;
  } // Get merged search context using utility function


  const mergedSearchContext = (0,analyticsUtils/* getMergedSearchContext */.Nm)(searchContext);
  const adobeAnalytics = (0,analyticsUtils/* getAdobeAnalytics */.ag)(mergedSearchContext, eventData?.event_detail?.components?.content_details); // Create event data with merged search context

  const eventDataWithSearchContext = _objectSpread(_objectSpread({}, eventData), {}, {
    search_context: mergedSearchContext,
    adobe_analytics: adobeAnalytics
  });

  const analyticsEvent = (0,analyticsUtils/* createAnalyticsEvent */.E2)(cachedPageData, eventDataWithSearchContext);
  pushToSdkEvent(analyticsEvent);
};
/**
 * Track manual events - call on-demand for user interactions
 * Merges event-specific data with cached page data and search context
 */

const errorTrackEvent = (eventData, searchContext) => {
  const cachedPageData = (0,analyticsUtils/* getCachedPageData */.E5)();

  if (!cachedPageData) {
    console.warn("Page tracking not initialized. Call initializePageTracking first.");
    return;
  } // Get merged search context using utility function


  const mergedSearchContext = (0,analyticsUtils/* getMergedSearchContext */.Nm)(searchContext);
  const adobeAnalytics = (0,analyticsUtils/* getAdobeAnalytics */.ag)(mergedSearchContext, eventData?.event_detail?.components?.content_details, eventData?.error_details_list); // Create event data with merged search context

  const eventDataWithSearchContext = _objectSpread(_objectSpread({}, eventData), {}, {
    event_detail: {
      event_value: "error",
      event_name: "error",
      event_type: "action"
    },
    search_context: mergedSearchContext,
    adobe_analytics: adobeAnalytics
  });

  const analyticsEvent = (0,analyticsUtils/* createAnalyticsEvent */.E2)(cachedPageData, eventDataWithSearchContext);
  pushToSdkEvent(analyticsEvent);
};
/**
 * Manually trigger page exit event - call during component unmount
 * This is useful for React component cleanup or manual exit tracking
 */

const triggerPageExit = () => {
  (0,analyticsUtils/* handlePageExit */.R5)();
};
/**
 * Update search context - call to update the search context
 * @param searchContext Search context to update
 */

const updateSearchContext = searchContext => {
  (0,analyticsUtils/* getMergedSearchContext */.Nm)(searchContext);
};
/**
 * Track component view - call when a component is viewed
 * @param input Component view data to track
 */

const trackComponentView = input => {
  (0,analyticsUtils/* trackComponentView */.po)(input);
};
/**
 * Get all tracked component views and clear cache
 * @returns ComponentViewResult with all tracked components
 */

const getComponentViewsAndClear = () => {
  return getComponentViewsAndClearUtil();
};

/***/ }),

/***/ 42874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JB": () => (/* binding */ fontSize),
/* harmony export */   "rS": () => (/* binding */ theme)
/* harmony export */ });
/* unused harmony exports fontWeight, lineHeight */
const theme = {
  blackText: "#000",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#007E7D",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "#717171",
  greyText10: "#c8c2c2",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  blueText2: "#F6FAFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  greenBg: "rgba(43, 130, 94, 0.5)",
  purpleGradient: "linear-gradient(91.22deg, #3023ae 1.88%, #c86dd7 100%)",
  blueGradient: "linear-gradient(to right,#53B2FE,#065AF3)",
  myBizGradient: "linear-gradient(104.41deg, #FF7E40 0%, #FF405D 99.23%)",
  neonGreen: "#E6FFF9",
  orange: "#FF6E39",
  disabledGrey: "#0000004D",
  disabledGrey2: "#F2F2F2",
  darkGreyBg: "#E7E7E7",
  lightBlueBg: "#EAF5FF",
  lightGreyBG: "#f4f4f4"
};
const fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
const fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
const lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};

/***/ }),

/***/ 78521:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HL": () => (/* reexport */ checkCheckoutEligibility),
  "oe": () => (/* reexport */ editInsuranceDetails),
  "$P": () => (/* reexport */ getNextPageRouteDetails),
  "Ko": () => (/* reexport */ getOrdersMyPartner),
  "aK": () => (/* reexport */ getSuggestionsInfo),
  "kk": () => (/* reexport */ hitRetailConsentMyPartner),
  "S8": () => (/* reexport */ sendPolicyEmail)
});

// UNUSED EXPORTS: paymentCheckout

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/api-utils/src/index.ts + 6 modules
var src = __webpack_require__(91973);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/getDeviceId.ts
var getDeviceId = __webpack_require__(60236);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/config.ts

const _excluded = ["cookie"];



const AXIOS_HTTPS_CONFIG = {
  timeout: src/* API_TIMEOUT_IN_MS */.Sb,
  withCredentials: true,
  retry: 1
};
const config_API_HTTPS = axios_default().create(AXIOS_HTTPS_CONFIG);
config_API_HTTPS.interceptors.request.use(function (config) {
  const _interceptors$enhance = src/* interceptors.enhanceRequestHeaders */.JQ.enhanceRequestHeaders(config.headers),
        {
    cookie
  } = _interceptors$enhance,
        headersWithoutCookie = (0,objectWithoutProperties/* default */.Z)(_interceptors$enhance, _excluded);

  config.headers = headersWithoutCookie;
  return config;
});
config_API_HTTPS.interceptors.response.use(response => {
  return response;
}, async error => {
  return src/* interceptors.retryAxiosRequest */.JQ.retryAxiosRequest(error, config_API_HTTPS);
});
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/apiRoutes.ts


const apiRoutes_excluded = ["partner", "query"],
      _excluded2 = ["partner", "query"],
      _excluded3 = ["partner", "query"],
      _excluded4 = ["partner", "query"],
      _excluded5 = ["query"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const paymentCheckout = async reqData => {
  try {
    const {
      partner = getPartnerOnClientSide(),
      data,
      query
    } = reqData;
    const params = {
      context: CONTEXT.STANDALONE_V2,
      ins_new_flow: true,
      lob: getLobOnClientSide(partner),
      itineraryId: data?.query?.itineraryId
    };
    const urlParams = setURLQueryParams(params);
    const dvid = getDeviceIdForClient();
    const apiRoutePrefix = getHTTPSRoutePrefixOnClientSide(partner);
    const pathPartner = getPathPartnerOnClientSide(partner);
    const response = await API_HTTPS.post(`${apiRoutePrefix}/${pathPartner}/${API_ROUTES.PAYMENT_CHECKOUT}${urlParams ? `?${urlParams}` : ""}`, data, {
      headers: {
        cmp: sessionStorage.getItem("cmp") || "fallback",
        dvid: dvid || ""
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error", {
      error
    });
    throw error;
  }
};
const sendPolicyEmail = async data => {
  try {
    const {
      bookingId,
      partner
    } = data;
    const params = {
      bookingID: bookingId
    };
    const urlParams = (0,utils/* setURLQueryParams */.jT)(params);
    const dvid = (0,getDeviceId/* getDeviceIdForClient */.f)();
    const pathPartner = (0,utils/* getPathPartnerOnClientSide */.Pg)(partner);
    const response = await config_API_HTTPS.post(`${src/* API_ROUTE_PREFIX_HTTPS */.j6}/${pathPartner}/${src/* API_ROUTES.TRIGGER_EMAIL */.qf.TRIGGER_EMAIL}${urlParams ? `?${urlParams}` : ""}`, {
      headers: {
        cmp: sessionStorage.getItem("cmp") || "fallback",
        dvid: dvid || ""
      }
    });
    return response?.data;
  } catch (error) {
    console.log("Error", {
      error: error.message
    });
    throw error;
  }
};
const editInsuranceDetails = async reqData => {
  try {
    const {
      bookingID,
      partner = (0,utils/* getPartnerOnClientSide */.et)(),
      data = []
    } = reqData;
    if (!bookingID) throw "editInsuranceDetails: Booking id not present or invalid";
    const urlParams = (0,utils/* setURLQueryParams */.jT)({
      bookingID
    });
    const dvid = (0,getDeviceId/* getDeviceIdForClient */.f)();
    const pathPartner = (0,utils/* getPathPartnerOnClientSide */.Pg)(partner);
    const response = await config_API_HTTPS.put(`${src/* API_ROUTE_PREFIX_HTTPS */.j6}/${pathPartner}/${src/* API_ROUTES.EDIT_INSURANCE_DETAILS */.qf.EDIT_INSURANCE_DETAILS}${urlParams ? `?${urlParams}` : ""}`, data, {
      headers: {
        cmp: sessionStorage.getItem("cmp") || "fallback",
        dvid: dvid || ""
      }
    });
    return response?.data;
  } catch (error) {
    console.error("Error", {
      error
    });
    throw error;
  }
};
const getNextPageRouteDetails = async reqData => {
  const {
    partner = isomorphic_utils_src.PARTNER.MMT,
    query
  } = reqData,
        data = (0,objectWithoutProperties/* default */.Z)(reqData, apiRoutes_excluded);

  const dvid = (0,getDeviceId/* getDeviceIdForClient */.f)();

  const params = _objectSpread({
    lob: (0,utils/* getLobOnClientSide */.Py)(partner),
    platform: isomorphic_utils_src.PLATFORM.WEB,
    context: isomorphic_utils_src.CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner
  }, query);

  const urlParams = new URLSearchParams(params).toString();
  let url;

  if (partner === isomorphic_utils_src.PARTNER.MYPARTNER || partner === isomorphic_utils_src.PARTNER.MYBIZ) {
    url = `${src/* API_ROUTE_V2_PREFIX_HTTPS */.UO}/mmt/${src/* API_ROUTES.GET_NEXT_PAGE_ROUTE */.qf.GET_NEXT_PAGE_ROUTE}?${urlParams}`;
  } else {
    url = `${src/* API_ROUTE_PREFIX_HTTPS */.j6}/${partner}/${src/* API_ROUTES.GET_NEXT_PAGE_ROUTE */.qf.GET_NEXT_PAGE_ROUTE}?${urlParams}`;
  }

  const response = await config_API_HTTPS.post(url, data, {
    headers: {
      dvid: dvid || "",
      cmp:  true && sessionStorage.getItem("cmp") || query?.["cmp"] || "fallback"
    }
  });

  if (partner === isomorphic_utils_src.PARTNER.MYPARTNER || partner === isomorphic_utils_src.PARTNER.MYBIZ) {
    return {
      responseStatus: response.data?.responseStatus,
      nextPageRouteConfig: response.data?.data?.nextPageRouteConfig
    };
  }

  return response.data;
};
const hitRetailConsentMyPartner = async reqData => {
  const {
    partner = isomorphic_utils_src.PARTNER.MYPARTNER,
    query
  } = reqData,
        data = (0,objectWithoutProperties/* default */.Z)(reqData, _excluded2);

  const dvid = (0,getDeviceId/* getDeviceIdForClient */.f)();

  const params = _objectSpread({
    lob: (0,utils/* getLobOnClientSide */.Py)(partner),
    platform: isomorphic_utils_src.PLATFORM.WEB,
    context: isomorphic_utils_src.CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner
  }, query);

  const urlParams = new URLSearchParams(params).toString();
  const url = `${src/* API_ROUTE_PREFIX_HTTPS */.j6}/${src/* API_ROUTES.HIT_RETAIL_CONSENT */.qf.HIT_RETAIL_CONSENT}?${urlParams}`;
  const response = await config_API_HTTPS.post(url, data, {
    headers: {
      dvid: dvid || ""
    }
  });
  return response.data;
};
const getOrdersMyPartner = async reqData => {
  const {
    partner = isomorphic_utils_src.PARTNER.MYPARTNER,
    query
  } = reqData,
        data = (0,objectWithoutProperties/* default */.Z)(reqData, _excluded3);

  const dvid = (0,getDeviceId/* getDeviceIdForClient */.f)();

  const params = _objectSpread({
    lob: (0,utils/* getLobOnClientSide */.Py)(partner),
    platform: isomorphic_utils_src.PLATFORM.WEB,
    context: isomorphic_utils_src.CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner
  }, query);

  const urlParams = new URLSearchParams(params).toString();
  const url = `${src/* API_ROUTE_PREFIX_HTTPS */.j6}/${src/* API_ROUTES.GET_ORDERS_RETAIL_MYPARTNER */.qf.GET_ORDERS_RETAIL_MYPARTNER}?${urlParams}`;
  const response = await config_API_HTTPS.get(url, {
    params: data,
    headers: {
      dvid: dvid || ""
    }
  });
  return response.data;
};
const checkCheckoutEligibility = async reqData => {
  const {
    partner = isomorphic_utils_src.PARTNER.MMT,
    query
  } = reqData,
        data = (0,objectWithoutProperties/* default */.Z)(reqData, _excluded4);

  const dvid = (0,getDeviceId/* getDeviceIdForClient */.f)();

  const params = _objectSpread({
    lob: isomorphic_utils_src.LOB.STANDALONE,
    platform: isomorphic_utils_src.PLATFORM.WEB,
    context: isomorphic_utils_src.CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner
  }, query);

  const urlParams = new URLSearchParams(params).toString();
  const url = `${src/* API_ROUTE_PREFIX_HTTPS */.j6}/${partner}/${src/* API_ROUTES.CHECK_CHECKOUT_ELIGIBILITY */.qf.CHECK_CHECKOUT_ELIGIBILITY}?${urlParams}`;
  const response = await config_API_HTTPS.post(url, data, {
    headers: {
      dvid: dvid || ""
    }
  });
  return response.data;
};
const getSuggestionsInfo = async reqData => {
  const {
    query
  } = reqData,
        data = (0,objectWithoutProperties/* default */.Z)(reqData, _excluded5);

  const params = _objectSpread({
    lob: isomorphic_utils_src.LOB.STANDALONE_MYBIZ,
    platform: isomorphic_utils_src.PLATFORM.WEB,
    context: isomorphic_utils_src.CONTEXT.STANDALONE_V2,
    partner: isomorphic_utils_src.PARTNER.MYBIZ
  }, query);

  const dvid = (0,getDeviceId/* getDeviceIdForClient */.f)();
  const urlParams = new URLSearchParams(params).toString();
  const url = `${src/* API_ROUTE_V2_PREFIX_HTTPS */.UO}/mmt/${src/* API_ROUTES.GET_SUGGESTIONS_INFO */.qf.GET_SUGGESTIONS_INFO}?${urlParams}`;
  const response = await config_API_HTTPS.post(url, data, {
    headers: {
      dvid: dvid || ""
    }
  });
  return response.data;
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/index.ts


/***/ }),

/***/ 576:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X_": () => (/* reexport */ PAGE_NAME_CONSTANTS),
  "ej": () => (/* reexport */ navigationActions),
  "Ro": () => (/* reexport */ navigationActionsSeo),
  "Nq": () => (/* reexport */ pageStack),
  "OD": () => (/* reexport */ setRouter)
});

// UNUSED EXPORTS: setRouterSeo

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/routeConstants.ts
var routeConstants = __webpack_require__(60251);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/navigator.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


let router;
const setRouter = routerInstance => {
  if (!routerInstance) {
    throw new Error("Couldn't set router,routerInstance object is null or undefined");
  }

  router = routerInstance;
};

function getURLFromRouteAndParams(route, params) {
  let searchParams = "";
  const routeParts = route.split("?");
  const baseRoute = routeParts[0];
  const existingParams = routeParts[1] ? new URLSearchParams(routeParts[1]) : new URLSearchParams();
  Object.keys(params || {}).forEach(key => existingParams.set(key, params[key]));
  searchParams = existingParams.toString();
  const queryJoin = searchParams.length > 0 ? "?" : "";
  return `${baseRoute}${queryJoin}${searchParams}`;
}
/* istanbul ignore next */


function forceRedirectOnWwwSubdomain(pathName) {
  if (typeof location === "undefined") return;
  const host = new URL(location.href).host;

  switch (host) {
    case "insurance.makemytrip.com":
      location.href = `https://www.makemytrip.com/insurance${pathName}`;
      break;

    case "insurance.goibibo.com":
      location.href = `https://www.goibibo.com/insurance${pathName}`;
      break;

    default:
      router.push(pathName);
  }
}

function forceRedirectOnInsuranceSubdomain(pathName) {
  if (typeof location === "undefined") return;
  const host = new URL(location.href).host;

  switch (host) {
    case "www.makemytrip.com":
      location.href = `https://insurance.makemytrip.com/insurance${pathName}`;
      break;

    case "www.goibibo.com":
      location.href = `https://insurance.goibibo.com/insurance${pathName}`;
      break;

    default:
      router.push(pathName);
  }
}

function injectCmpInParams(params) {
  const cmpVal = sessionStorage.getItem("cmp");

  if (typeof cmpVal === "string" && cmpVal != "") {
    params = _objectSpread(_objectSpread({}, params), {}, {
      cmp: cmpVal
    });
  }

  return params;
}

const navigationActions = {
  navigateToLanding: (params, shouldForceRedirectOnWwwSubdomain = true) => {
    params = injectCmpInParams(params);
    const pathName = getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.LANDING_PAGE */.j.LANDING_PAGE, params);
    router.push(pathName);
  },
  navigateToListing: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.LISTING_SCREEN */.j.LISTING_SCREEN, params));
  },
  navigateToCommonLanding: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.COMMON_LANDING */.j.COMMON_LANDING, params));
  },
  navigateToTravellerDetails: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.TRAVELLER_DETAILS */.j.TRAVELLER_DETAILS, params));
  },
  navigateToAddPassport: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.ADD_PASSPORT */.j.ADD_PASSPORT, params));
  },
  navigateToOrderConfirmed: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.ORDER_CONFIRMED */.j.ORDER_CONFIRMED, params));
  },
  navigateToOrderListing: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.ORDER_LISTING */.j.ORDER_LISTING, params));
  },
  navigateToOrderDetails: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.ORDER_DETAILS */.j.ORDER_DETAILS, params));
  },
  navigateToDownloadPolicy: params => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(routeConstants/* ROUTE_CONSTANTS.DOWNLOAD_POLICY */.j.DOWNLOAD_POLICY, params));
  },
  goBack: ({
    forceExit
  } = {}) => {
    if (forceExit) {
      window.history.go(-(window.history.length - 2));
    } else {
      router.back();
    }
  },
  navigateToPageByRouteName: (route, params) => {
    params = injectCmpInParams(params);
    router.push(getURLFromRouteAndParams(route, params));
  },
  navigateToRouteNameWithHostname: (route, params) => {
    params = injectCmpInParams(params);
    const hostname = window.location.hostname;
    const routeWithHostname = `${hostname}${getURLFromRouteAndParams(route, params)}`;
    location.href = `https://${routeWithHostname}`;
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/routeConstantsSeo.ts
const ROUTE_CONSTANTS_SEO = {
  LANDING_PAGE: "/insurance",
  LISTING_SCREEN: "/insurance/listing",
  TRAVELLER_DETAILS: "/insurance/traveller-details",
  PAYMENT_SUCCESS: "/insurance/paymentSuccess",
  PAYMENT_FAILURE: "/insurance/payment-failure",
  ADD_PASSPORT: "/insurance/add-passport",
  ORDER_CONFIRMED: "/insurance/order-confirmed",
  ORDER_LISTING: "/insurance/order-listing",
  ORDER_DETAILS: "/insurance/order-details",
  EDIT_TRAVELLERS: "/insurance/edit-travellers",
  DOWNLOAD_POLICY: "/insurance/download-policy",
  WEBVIEW_SCREEN: "/insurance/webview-screen",
  COMMON_LANDING: "/insurance/common-landing"
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/navigatorSeo.ts


function navigatorSeo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function navigatorSeo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? navigatorSeo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : navigatorSeo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


let navigatorSeo_router;
const setRouterSeo = routerInstance => {
  if (!routerInstance) {
    throw new Error("Couldn't set router,routerInstance object is null or undefined");
  }

  navigatorSeo_router = routerInstance;
};

function navigatorSeo_getURLFromRouteAndParams(route, params) {
  let searchParams = "";
  const routeParts = route.split("?");
  const baseRoute = routeParts[0];
  const existingParams = routeParts[1] ? new URLSearchParams(routeParts[1]) : new URLSearchParams();
  Object.keys(params || {}).forEach(key => existingParams.set(key, params[key]));
  searchParams = existingParams.toString();
  const queryJoin = searchParams.length > 0 ? "?" : "";
  return `${baseRoute}${queryJoin}${searchParams}`;
}
/* istanbul ignore next */


function navigatorSeo_forceRedirectOnWwwSubdomain(pathName) {
  if (typeof location === "undefined") return;
  const host = new URL(location.href).host;

  switch (host) {
    case "insurance.makemytrip.com":
      location.href = `https://www.makemytrip.com${pathName}`;
      break;

    case "insurance.goibibo.com":
      location.href = `https://www.goibibo.com${pathName}`;
      break;

    default:
      navigatorSeo_router.push(pathName);
  }
}

function navigatorSeo_forceRedirectOnInsuranceSubdomain(pathName) {
  if (typeof location === "undefined") return;
  const host = new URL(location.href).host;

  switch (host) {
    case "www.makemytrip.com":
      location.href = `https://insurance.makemytrip.com${pathName}`;
      break;

    case "www.goibibo.com":
      location.href = `https://insurance.goibibo.com${pathName}`;
      break;

    default:
      navigatorSeo_router.push(pathName);
  }
}

function navigatorSeo_injectCmpInParams(params) {
  const cmpVal = sessionStorage.getItem("cmp");

  if (typeof cmpVal === "string" && cmpVal != "") {
    params = navigatorSeo_objectSpread(navigatorSeo_objectSpread({}, params), {}, {
      cmp: cmpVal
    });
  }

  return params;
}

const navigationActionsSeo = {
  navigateToLanding: (params, shouldForceRedirectOnWwwSubdomain = true) => {
    params = navigatorSeo_injectCmpInParams(params);
    const pathName = navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.LANDING_PAGE, params);
    shouldForceRedirectOnWwwSubdomain ? navigatorSeo_forceRedirectOnWwwSubdomain(pathName) : navigatorSeo_router.push(pathName);
  },
  navigateToListing: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.LISTING_SCREEN, params));
  },
  navigateToCommonLanding: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.COMMON_LANDING, params));
  },
  navigateToTravellerDetails: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.TRAVELLER_DETAILS, params));
  },
  navigateToAddPassport: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.ADD_PASSPORT, params));
  },
  navigateToOrderConfirmed: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.ORDER_CONFIRMED, params));
  },
  navigateToOrderListing: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.ORDER_LISTING, params));
  },
  navigateToOrderDetails: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.ORDER_DETAILS, params));
  },
  navigateToDownloadPolicy: params => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(ROUTE_CONSTANTS_SEO.DOWNLOAD_POLICY, params));
  },
  goBack: ({
    forceExit
  } = {}) => {
    if (forceExit) {
      window.history.go(-(window.history.length - 2));
    } else {
      navigatorSeo_router.back();
    }
  },
  navigateToPageByRouteName: (route, params) => {
    params = navigatorSeo_injectCmpInParams(params);
    console.log("-----params", params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(route, params));
  },
  navigateToRouteNameWithHostname: (route, params) => {
    params = navigatorSeo_injectCmpInParams(params);
    navigatorSeo_forceRedirectOnInsuranceSubdomain(navigatorSeo_getURLFromRouteAndParams(route, params));
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/pageNameConstants.ts
/**
 * Page name constants for navigation stack tracking
 * Used to identify pages in the pageStack for conditional UI logic
 */
const PAGE_NAME_CONSTANTS = {
  COMMON_LANDING: "COMMON_LANDING",
  LANDING: "LANDING",
  LISTING: "LISTING",
  TRAVELLER_DETAILS: "REVIEW",
  // TravellerDetails page maps to REVIEW in analytics
  ORDER_CONFIRMED: "THANK_YOU_POLICY",
  // OrderConfirmed maps to THANK_YOU_POLICY
  ORDER_DETAILS: "ORDER_DETAILS",
  ADD_PASSPORT: "ADD_PASSPORT",
  ORDER_LISTING: "ORDER_LISTING",
  DOWNLOAD_POLICY: "ORDER_DETAILS",
  // DownloadPolicy is accessed from OrderDetails
  EDIT_TRAVELLERS: "REVIEW" // EditTravellerDetails is part of review flow

};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/pageStack.ts


/**
 * Stack utility for managing navigation page history
 * Used to track user navigation flow and enable conditional UI based on previous page
 */
class PageStack {
  constructor() {
    (0,defineProperty/* default */.Z)(this, "stack", []);
  }

  /**
   * Push a page name onto the stack
   * @param pageName - The name of the page to push
   */
  push(pageName) {
    if (pageName) {
      this.stack.push(pageName);
    }
  }
  /**
   * Pop the top page name from the stack
   * @returns The popped page name or undefined if stack is empty
   */


  pop() {
    return this.stack.pop();
  }
  /**
   * Get the top page name without removing it
   * @returns The top page name or undefined if stack is empty
   */


  peek() {
    return this.stack.length > 0 ? this.stack[this.stack.length - 1] : undefined;
  }
  /**
   * Get the previous page name (second from top) without removing it
   * @returns The previous page name or undefined if stack has less than 2 items
   */


  getPreviousPage() {
    return this.stack.length >= 2 ? this.stack[this.stack.length - 2] : undefined;
  }
  /**
   * Get the current size of the stack
   * @returns The number of pages in the stack
   */


  size() {
    return this.stack.length;
  }
  /**
   * Check if the stack is empty
   * @returns True if stack is empty, false otherwise
   */


  isEmpty() {
    return this.stack.length === 0;
  }
  /**
   * Clear all pages from the stack
   */


  clear() {
    this.stack = [];
  }
  /**
   * Get all pages in the stack (for debugging)
   * @returns A copy of the stack array
   */


  getAllPages() {
    return [...this.stack];
  }

} // Export a singleton instance


const pageStack = new PageStack();
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts





/***/ }),

/***/ 60251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": () => (/* binding */ ROUTE_CONSTANTS)
/* harmony export */ });
const ROUTE_CONSTANTS = {
  LANDING_PAGE: "/",
  LISTING_SCREEN: "/listing",
  TRAVELLER_DETAILS: "/traveller-details",
  PAYMENT_SUCCESS: "/paymentSuccess",
  PAYMENT_FAILURE: "/payment-failure",
  ADD_PASSPORT: "/add-passport",
  ORDER_CONFIRMED: "/order-confirmed",
  ORDER_LISTING: "/order-listing",
  ORDER_DETAILS: "/order-details",
  EDIT_TRAVELLERS: "/edit-travellers",
  DOWNLOAD_POLICY: "/download-policy",
  WEBVIEW_SCREEN: "/webview-screen",
  COMMON_LANDING: "/common-landing",
  INSURANCE_V1_LANDING: "/insurance"
};

/***/ }),

/***/ 4120:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IZ": () => (/* binding */ calendarLabelFormatter),
/* harmony export */   "P9": () => (/* binding */ convertUnixToDate),
/* harmony export */   "Xz": () => (/* binding */ addDaysToDate),
/* harmony export */   "cJ": () => (/* binding */ convertDateToUnix),
/* harmony export */   "p6": () => (/* binding */ formatDate),
/* harmony export */   "rv": () => (/* binding */ subtractYrsFromDate)
/* harmony export */ });
/* unused harmony exports randomDayData, subtractDurationFromDate */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91997);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);

 // CALENDAR UTILITY FUNCTIONS

const randomDayData = () => {
  const min = 10000;
  const max = 15000;
  const randomNum = Math.floor(Math.random() * (max - min + 1) + min);
  return {
    price: `₹${randomNum}`,
    class: randomNum <= 12000 ? "greenText" : "redText",
    isSoldOut: randomNum > 12000 && randomNum < 13000,
    availableOnPreviousDate: randomNum >= 13000 && randomNum <= 13500
  };
};
const convertUnixToDate = unix => {
  if (unix) {
    return new Date(unix * 1000);
  }

  return;
};
const convertDateToUnix = date => {
  return Math.floor(new Date(date).getTime() / 1000);
};
const formatDate = (date, dateFormat) => {
  if (date) {
    try {
      date = new Date(date);
      return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .format */ .WUZ)(date, dateFormat);
    } catch (error) {
      /* istanbul ignore next */
      console.log("Error in formatting given date", `${date} | ${dateFormat}`);
    }
  }

  return "";
};
const addDaysToDate = (date, days = 1) => {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .addDays */ .E4D)(date, days);
  } catch (error) {
    /* istanbul ignore next */
    console.log("Error in adding given days to date", `${date} | ${days}`);
  }
  /* istanbul ignore next */


  return;
};
const subtractDurationFromDate = (date, duration) => {
  if (date) {
    try {
      date = new Date(date);
      return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .sub */ .luU)(date, duration);
    } catch (error) {
      /* istanbul ignore next */
      console.log("Error in subtracting given duration from date", `${date} | ${duration}`);
    }
  }
  /* istanbul ignore next */


  return new Date();
};
const subtractYrsFromDate = (date, years) => {
  if (date && years) {
    try {
      return subtractDurationFromDate(date, {
        years
      });
    } catch (error) {
      /* istanbul ignore next */
      console.log("Error in subtracting given years from date", `${date} | ${years}`);
    }
  }
  /* istanbul ignore next */


  return new Date();
};
const calendarLabelFormatter = dateObj => {
  return dateObj ? `${dateObj.getDate()} ${_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.MONTHS[dateObj.getMonth()]}' ${dateObj.getFullYear().toString().slice(-2)}` : `${new Date().getDate()} ${_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.MONTHS[new Date().getMonth()]}' ${new Date().getFullYear().toString().slice(-2)}`;
};

/***/ }),

/***/ 60236:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ getDeviceIdForClient)
/* harmony export */ });
/* unused harmony export getDeviceIdForServer */
/* harmony import */ var _growth_visitor_id_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19630);
/* harmony import */ var _growth_visitor_id_node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6435);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44928);
/* harmony import */ var MMT_UI_helpers_client_dvid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60547);
/* harmony import */ var MMT_UI_helpers_client_dvid__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_helpers_client_dvid__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var MMT_UI_helpers_server_dvid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90317);
/* harmony import */ var MMT_UI_helpers_server_dvid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_helpers_server_dvid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78892);
/* eslint-disable @typescript-eslint/ban-ts-comment */


 // @ts-ignore

 // @ts-ignore



const getDeviceIdForClient = () => {
  if (false) {}

  try {
    const partner = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getPartnerOnClientSide */ .et)();

    if (partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.GI) {
      const vid = (0,_growth_visitor_id_browser__WEBPACK_IMPORTED_MODULE_0__/* .getVisitorIdBrowser */ .MI)();
      return vid;
    } else {
      const dvid = (0,MMT_UI_helpers_client_dvid__WEBPACK_IMPORTED_MODULE_3__.getAndUpdateDvid)();
      return dvid;
    }
  } catch (error) {
    console.error("Error in getDeviceIdForClient utility:", error);
    return null;
  }
};
const getDeviceIdForServer = (req, res, partner) => {
  try {
    let dvid = null;

    if (partner === PARTNER.GI) {
      const vidMiddleware = visitorIdNode();
      vidMiddleware(req, res, () => {// Middleware callback
      });
      dvid = getVisitorIdNode(req);
    } else {
      dvid = getAndUpdateDvidOnServer(req, res);
    }

    return dvid;
  } catch (error) {
    console.error("Error in getDeviceId utility:", error);
    return null;
  }
};

/***/ }),

/***/ 62663:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xz": () => (/* reexport */ dateUtils/* addDaysToDate */.Xz),
  "IZ": () => (/* reexport */ dateUtils/* calendarLabelFormatter */.IZ),
  "cJ": () => (/* reexport */ dateUtils/* convertDateToUnix */.cJ),
  "P9": () => (/* reexport */ dateUtils/* convertUnixToDate */.P9),
  "Ds": () => (/* reexport */ utils/* debounce */.Ds),
  "Gz": () => (/* reexport */ downloadPdfPost),
  "fQ": () => (/* reexport */ downloadTemplate),
  "p6": () => (/* reexport */ dateUtils/* formatDate */.p6),
  "sI": () => (/* reexport */ utils/* generateSourceSetImageUrl */.sI),
  "A7": () => (/* reexport */ utils/* getCookieByName */.A7),
  "fV": () => (/* reexport */ getDeviceId/* getDeviceIdForClient */.f),
  "YV": () => (/* reexport */ utils/* getFormFieldErrorMsg */.YV),
  "Py": () => (/* reexport */ utils/* getLobOnClientSide */.Py),
  "et": () => (/* reexport */ utils/* getPartnerOnClientSide */.et),
  "Pg": () => (/* reexport */ utils/* getPathPartnerOnClientSide */.Pg),
  "K_": () => (/* reexport */ utils/* getRandomBgImage */.K_),
  "JD": () => (/* reexport */ utils/* getThemePartner */.JD),
  "fP": () => (/* reexport */ getTravDetailsFromMemory),
  "iX": () => (/* reexport */ utils/* hydrateVars */.iX),
  "IS": () => (/* reexport */ utils/* interpolateRowHeight */.Xz),
  "qP": () => (/* reexport */ utils/* isDobValid */.qP),
  "K0": () => (/* reexport */ utils/* isFieldValid */.K0),
  "xA": () => (/* reexport */ utils/* isMyBiz */.xA),
  "bR": () => (/* reexport */ utils/* isMyPartner */.bR),
  "Pk": () => (/* reexport */ utils/* isPartnerGI */.Pk),
  "rS": () => (/* reexport */ utils/* isPartnerMMT */.rS),
  "df": () => (/* reexport */ utils/* replaceHistory */.df),
  "_A": () => (/* reexport */ utils/* replaceHistoryRemoveParams */._A),
  "Yp": () => (/* reexport */ setTravDetailsInMemory),
  "jT": () => (/* reexport */ utils/* setURLQueryParams */.jT),
  "rv": () => (/* reexport */ dateUtils/* subtractYrsFromDate */.rv)
});

// UNUSED EXPORTS: COUNTRY_BANNER_CONFIG, deepMergeObjects, getDeviceIdForServer, getHTTPSRoutePrefixOnClientSide, getTrackCookies, isHostMakemytrip, isObject, openCheckoutPage, persistUtmParams, randomDayData, setCookie, subtractDurationFromDate

;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/checkout.ts
const openCheckoutPage = checkoutUrl => {
  try {
    if (!checkoutUrl) {
      /* istanbul ignore next */
      throw new Error(`Required parameters missing from native checkout bridge. checkoutUrl: ${checkoutUrl}`);
    }

    window?.open(checkoutUrl, "_self");
  } catch (error) {
    console?.log("PAYMENT REDIRECTION FAILED", error);
    /* istanbul ignore next */

    throw error;
  }
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/dateUtils.ts
var dateUtils = __webpack_require__(4120);
// EXTERNAL MODULE: ../../libs/api-utils/src/index.ts + 6 modules
var src = __webpack_require__(91973);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/downloadTemplate.ts


const downloadTemplate = async itineraryId => {
  try {
    const response = await fetch(`${src/* API_ROUTE_V2_PREFIX_HTTPS */.UO}/${isomorphic_utils_src.PARTNER.MMT}/${src/* API_ROUTES.DOWNLOAD_TEMPLATE */.qf.DOWNLOAD_TEMPLATE}?itineraryId=${itineraryId}`, {
      method: "GET"
    });

    if (!response.ok) {
      // Try to parse error response to extract error.message.description
      let errorMessage = `HTTP error! status: ${response.status}`;

      try {
        const errorData = await response.json();
        const errorDescription = errorData?.error?.message?.description;

        if (errorDescription) {
          errorMessage = errorDescription;
        }
      } catch {// JSON parsing failed, use default error message
      }

      throw new Error(errorMessage);
    } // Extract filename from Content-Disposition header if available


    const contentDisposition = response.headers.get("Content-Disposition");
    let downloadFileName = "passenger_template.xlsx";

    if (contentDisposition) {
      // Try to extract filename from header (handles both filename="..." and filename*=UTF-8''...)
      const filenameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-8'')?([^"';\n]+)['"]?/i);

      if (filenameMatch && filenameMatch[1]) {
        downloadFileName = decodeURIComponent(filenameMatch[1]);
      }
    } // Get the blob from the response


    const blob = await response.blob(); // Create a download link

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = downloadFileName;
    document.body.appendChild(link);
    link.click(); // Cleanup

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
    throw error;
  }
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/getDeviceId.ts
var getDeviceId = __webpack_require__(60236);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/getTrackCookies.ts
function getTrackCookies(req) {
  const trackCookies = req.cookies["track"] || "";
  return trackCookies === "true";
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/pdfDownload.ts
const downloadPdfPost = async (quoteId, templateType, csrfToken, itineraryId) => {
  try {
    const response = await fetch(`/insurance/ext/api/v2/partners/mmt/insurance/cb/downloadPdf?itineraryId=${itineraryId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        tmBookingId: quoteId,
        templateType: templateType,
        csrfToken: csrfToken
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    } // Get the blob from the response


    const blob = await response.blob(); // Create a download link

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `policy_${templateType}_${quoteId}.pdf`;
    document.body.appendChild(link);
    link.click(); // Cleanup

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading PDF:", error);
    throw error;
  }
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/clientStorageUtils.ts
var clientStorageUtils = __webpack_require__(37290);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/travellerDetails.ts

const STORAGE_KEY = "insurance_traveller_details";
const setTravDetailsInMemory = value => {
  if (true) {
    try {
      (0,clientStorageUtils/* setSessionStorageItem */.D9)(STORAGE_KEY, value, true); // true = essential storage
    } catch (error) {
      console.error("Failed to save traveller details to session storage:", error);
    }
  }
};
const getTravDetailsFromMemory = () => {
  if (true) {
    try {
      return (0,clientStorageUtils/* getSessionStorageItem */.St)(STORAGE_KEY, true) || {};
    } catch (error) {
      console.error("Failed to retrieve traveller details from session storage:", error);
      return {};
    }
  }

  return {};
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/utils.ts
var utils = __webpack_require__(78892);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts









/***/ }),

/***/ 78892:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A7": () => (/* binding */ getCookieByName),
/* harmony export */   "Ds": () => (/* binding */ debounce),
/* harmony export */   "JD": () => (/* binding */ getThemePartner),
/* harmony export */   "K0": () => (/* binding */ isFieldValid),
/* harmony export */   "K_": () => (/* binding */ getRandomBgImage),
/* harmony export */   "Pg": () => (/* binding */ getPathPartnerOnClientSide),
/* harmony export */   "Pk": () => (/* binding */ isPartnerGI),
/* harmony export */   "Py": () => (/* binding */ getLobOnClientSide),
/* harmony export */   "Xz": () => (/* binding */ interpolateRowHeight),
/* harmony export */   "YV": () => (/* binding */ getFormFieldErrorMsg),
/* harmony export */   "_A": () => (/* binding */ replaceHistoryRemoveParams),
/* harmony export */   "bR": () => (/* binding */ isMyPartner),
/* harmony export */   "df": () => (/* binding */ replaceHistory),
/* harmony export */   "et": () => (/* binding */ getPartnerOnClientSide),
/* harmony export */   "iX": () => (/* binding */ hydrateVars),
/* harmony export */   "jT": () => (/* binding */ setURLQueryParams),
/* harmony export */   "qP": () => (/* binding */ isDobValid),
/* harmony export */   "rS": () => (/* binding */ isPartnerMMT),
/* harmony export */   "sI": () => (/* binding */ generateSourceSetImageUrl),
/* harmony export */   "xA": () => (/* binding */ isMyBiz)
/* harmony export */ });
/* unused harmony exports persistUtmParams, setCookie, isHostMakemytrip, isObject, deepMergeObjects, COUNTRY_BANNER_CONFIG, getHTTPSRoutePrefixOnClientSide */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_api_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91973);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44928);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59055);
/* harmony import */ var _dateUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4120);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const setURLQueryParams = (params = {}) => {
  const usp = new URLSearchParams();
  Object.keys(params).forEach(e => {
    if (params[e]) {
      usp.set(e, params[e].toString());
    }
  });
  return usp.toString();
};
const persistUtmParams = queryParam => {
  const utm_source = queryParam.get(UTM_PARAMS.UTM_SOURCE);
  const utm_medium = queryParam.get(UTM_PARAMS.UTM_MEDIUM);
  const utm_campaign = queryParam.get(UTM_PARAMS.UTM_CAMPAIGN);

  if (utm_source) {
    sessionStorage.setItem(UTM_PARAMS.UTM_SOURCE, utm_source);
  }

  if (utm_medium) {
    sessionStorage.setItem(UTM_PARAMS.UTM_MEDIUM, utm_medium);
  }

  if (utm_campaign) {
    sessionStorage.setItem(UTM_PARAMS.UTM_INS_CAMPAIGN, utm_campaign);
  }
};
const replaceHistory = (param, value) => {
  if (true) {
    const baseUrl = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    value?.length > 0 ? searchParams.set(param, value) : null;
    const url = `${baseUrl}${searchParams.toString().length > 0 ? "?" + searchParams : ""}`;
    window.history.replaceState(_objectSpread(_objectSpread({}, window.history.state), {}, {
      as: url,
      url: url
    }), "", url);
  }
};
const replaceHistoryRemoveParams = param => {
  const baseUrl = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(param);
  const url = `${baseUrl}${searchParams.toString().length > 0 ? "?" + searchParams : ""}`;
  window.history.replaceState(_objectSpread(_objectSpread({}, window.history.state), {}, {
    as: url,
    url: url
  }), "", url);
};
const getCookieByName = cookieName => {
  if ((0,_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.isOnServer)()) {
    return;
  }

  const cookie = {};
  document.cookie.split(";").forEach(el => {
    const [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};
function setCookie(name, value, milliseconds = 0) {
  const d = new Date();
  d.setTime(d.getTime() + milliseconds);
  const expires = "expires=" + d.toUTCString();
  document.cookie = `${name}=${value};${expires};path=/`;
}
const getFormFieldErrorMsg = (field, errorMsg) => {
  if (errorMsg) {
    return errorMsg;
  } else {
    const fieldName = _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.FORM_FIELDS_MAP[field] || field;
    return `Please enter ${fieldName}`;
  }
};
const isDobValid = (value, regex) => {
  if (!value) return false;
  const formattedDate = (0,_dateUtils__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(value, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.DATE_FORMATS["DD/MM/YYYY"]);
  const isValidDate = new RegExp(regex || "").test(formattedDate);
  return isValidDate;
};
const getPartnerOnClientSide = () => {
  const hostname = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getHostName */ .Lp)() || "";

  if (hostname.includes(_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER_DOMAIN_NAME.MYPARTNER)) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYPARTNER;
  } else if (hostname.includes(_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER_DOMAIN_NAME.MYBIZ)) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYBIZ;
  } else if (hostname.includes(_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER_DOMAIN_NAME.MMT)) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MMT;
  } else if (hostname.includes(_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER_DOMAIN_NAME.GI)) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.GI;
  } else if (hostname.includes(_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER_DOMAIN_NAME.TRIPMONEY)) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.TRIPMONEY;
  } else {
    console.error(`Error detecting partner. Unsupported domain hostname - ${hostname}`);
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.TRIPMONEY;
  }
};
const isPartnerMMT = () => {
  return getPartnerOnClientSide() === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MMT;
};
const isPartnerGI = () => {
  return getPartnerOnClientSide() === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.GI;
};
const isMyPartner = () => {
  return getPartnerOnClientSide() === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYPARTNER;
};
const isMyBiz = () => {
  return getPartnerOnClientSide() === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYBIZ;
};
const isFieldValid = (regex, updatedField) => {
  try {
    const validator = new RegExp(regex || "");
    return validator?.test(updatedField);
  } catch (error) {
    return false;
  }
};
const isHostMakemytrip = () => {
  if (isOnServer()) return false;
  const url = new URL(window.location.href);
  return TRIPMONEY_DOMAIN_NAME.MMT.includes(url.hostname);
};
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};
const generateSourceSetImageUrl = (cdnUrlWidths, imgUrl, width) => {
  let imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(width => `${imgUrl}?im=Resize=(${width}) ${width}w`).join(",");
};
const isObject = item => {
  return item && typeof item === "object" && !Array.isArray(item);
};
function deepMergeObjects(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!target[key]) target[key] = {};
        target[key] = deepMergeObjects(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  }

  return deepMergeObjects(target, ...sources);
}
//TODO: Check for a better way to handle the Dynamic size of cells in react-window
const interpolateRowHeight = (width, region, expansionLevel = 0) => {
  const heightData = {
    360: {
      normal: [57],
      WW: [57, 159],
      EU: [57, 183, 399],
      SEA: [57, 207, 207],
      WWEUC: [65.5, 215.5, 215]
    },
    370: {
      normal: [57],
      WW: [57, 159],
      SEA: [57, 183, 183],
      EU: [57, 183, 375],
      WWEUC: [65.5, 215.5, 191.5]
    },
    315: {
      normal: [57],
      WW: [57, 183],
      SEA: [57, 207, 231],
      EU: [57, 207, 471],
      WWEUC: [65.5, 215.5, 215.5]
    },
    354: {
      normal: [57],
      WW: [57, 159],
      SEA: [57, 207, 207],
      EU: [57, 183, 399],
      WWEUC: [65.5, 215.5, 215.5]
    },
    300: {
      normal: [57],
      WW: [57, 183],
      SEA: [57, 231, 231],
      EU: [57, 207, 495],
      WWEUC: [65.5, 239.5, 215.5]
    },
    708: {
      normal: [57],
      WW: [57, 135],
      SEA: [57, 159, 159],
      EU: [57, 159, 255],
      WWEUC: [65.5, 167.5, 143.5]
    },
    480: {
      normal: [57],
      WW: [57, 135],
      SEA: [57, 183, 159],
      EU: [57, 183, 303],
      WWEUC: [65.5, 215.5, 191.5]
    }
  };
  const availableWidths = Object.keys(heightData).map(Number).sort((a, b) => a - b);

  const findNearestWidths = targetWidth => {
    let lowerWidth = availableWidths[0];
    let upperWidth = availableWidths[availableWidths.length - 1];

    for (let i = 0; i < availableWidths.length - 1; i++) {
      if (availableWidths[i] <= targetWidth && availableWidths[i + 1] >= targetWidth) {
        lowerWidth = availableWidths[i];
        upperWidth = availableWidths[i + 1];
        break;
      }
    }

    return [lowerWidth, upperWidth];
  };

  const [lowerWidth, upperWidth] = findNearestWidths(width);
  const lowerHeights = heightData?.[lowerWidth]?.[region] || [57];
  const upperHeights = heightData?.[upperWidth]?.[region] || [57];
  const lowerHeight = lowerHeights[Math.min(expansionLevel, lowerHeights.length - 1)];
  const upperHeight = upperHeights[Math.min(expansionLevel, upperHeights.length - 1)];
  const interpolatedHeight = lowerHeight + (upperHeight - lowerHeight) * (width - lowerWidth) / (upperWidth - lowerWidth);
  return interpolatedHeight;
};
const COUNTRY_BANNER_CONFIG = {
  AE: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/UAE_New.png"
  },
  GB: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/UnitedKingdom.png"
  },
  KW: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/Kuwait.png"
  },
  BH: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/Bahrain.png"
  },
  OM: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/Oman.png"
  },
  QA: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/Qatar.png"
  },
  SA: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/HP/KSA/ksabg2.jpg"
  },
  WW: {
    bannerImage: "https://promos.makemytrip.com/Growth/Images/B2C/GCC/Worldwide.png"
  }
};
function getRandomBgImage(index) {
  // const cookieTag: string | undefined = getCookieByName("InsBgImgTag");
  // if (
  //   cookieTag &&
  //   COUNTRY_BANNER_CONFIG[cookieTag as keyof typeof COUNTRY_BANNER_CONFIG]
  // ) {
  //   return COUNTRY_BANNER_CONFIG[
  //     cookieTag as keyof typeof COUNTRY_BANNER_CONFIG
  //   ].bannerImage;
  // }
  // const keys = Object.keys(COUNTRY_BANNER_CONFIG);
  // const randomKey = keys[Math.floor(Math.random() * keys.length)];
  // // setCookie("InsBgImgTag", randomKey, 24 * 60 * 60 * 1000);
  // return COUNTRY_BANNER_CONFIG[randomKey as keyof typeof COUNTRY_BANNER_CONFIG]
  //   .bannerImage;
  const randomKey = Math.floor(Math.random() * 7);
  const images = ["bg1", "bg2", "bg3", "bg4", "bg5", "bg6", "bg7"];
  let bgImageIndex = null;

  if (true) {
    bgImageIndex = parseInt(localStorage.getItem("bgImageIndex") || "0");

    if (!bgImageIndex && !index) {
      bgImageIndex = randomKey;
    } else if (index && !bgImageIndex) {
      bgImageIndex = parseInt(index.toString());
    }

    localStorage.setItem("bgImageIndex", bgImageIndex.toString(10));
    setCookie("bgImageIndex", bgImageIndex.toString(10), 24 * 60 * 60 * 1000);
    return `https://imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/${images[bgImageIndex]}.jpg`;
  }

  if (index) {
    bgImageIndex = parseInt(index.toString());
  }

  if (bgImageIndex === null) {
    bgImageIndex = randomKey;
  }

  return `https://imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/${images[bgImageIndex]}.jpg`; // return null;
}
const getLobOnClientSide = partner => {
  if ((0,_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.isOnServer)()) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.LOB.STANDALONE;
  }

  if (partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYPARTNER) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.LOB.MYPARTNER;
  } else if (partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYBIZ) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.LOB.STANDALONE_MYBIZ;
  }

  return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.LOB.STANDALONE;
};
const getPathPartnerOnClientSide = partner => {
  if (partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYPARTNER || partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYBIZ) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MMT;
  }

  return partner;
};
const getHTTPSRoutePrefixOnClientSide = partner => {
  if (partner === PARTNER.MYPARTNER || partner === PARTNER.MYBIZ) {
    return API_ROUTE_V2_PREFIX_HTTPS;
  }

  return API_ROUTE_PREFIX_HTTPS;
};
function hydrateVars(input, overrideVars = {}) {
  if (Array.isArray(input)) {
    return input.map(item => hydrateVars(item, overrideVars));
  } else if (typeof input === "object" && input !== null) {
    const hydratedObject = {};

    for (const key in input) {
      if (key === "vars" && typeof input[key] === "object") {
        for (const varKey in input[key]) {
          const varValue = overrideVars[varKey] || input[key][varKey];

          for (const innerKey in hydratedObject) {
            if (typeof hydratedObject[innerKey] === "string") {
              hydratedObject[innerKey] = hydratedObject[innerKey].replace(`{{${varKey}}}`, varValue);
            }
          }
        }
      } else {
        hydratedObject[key] = hydrateVars(input[key], overrideVars);
      }
    }

    return hydratedObject;
  } else if (typeof input === "string") {
    return input.replace(/\{\{([^}]+)\}\}/g, (match, p1) => overrideVars && p1.trim() in overrideVars ? String(overrideVars[p1.trim()]) : match);
  }

  return input;
}
const getThemePartner = partner => {
  if (partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MYPARTNER) {
    return _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MMT;
  }

  return partner;
};

/***/ }),

/***/ 77809:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ WHITE_COLOR)
/* harmony export */ });
const WHITE_COLOR = {
  "60": "rgba(255, 255, 255, 0.6)"
};

/***/ }),

/***/ 37290:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D9": () => (/* binding */ setSessionStorageItem),
/* harmony export */   "St": () => (/* binding */ getSessionStorageItem),
/* harmony export */   "lD": () => (/* binding */ removeSessionStorageItem)
/* harmony export */ });
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30156);
/* harmony import */ var MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88456);
/* harmony import */ var MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59055);
// prettier-ignore
//@ts-ignore
 // prettier-ignore
//@ts-ignore



/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

const {
  ES,
  N_ES
} = MMT_UI_storages_client_localStorage__WEBPACK_IMPORTED_MODULE_0__.itemType;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
} // sesstion storage utils


function setSessionStorageItem(key, value, isEssential = false, options = {
  shouldStringifyJson: true
}) {
  options = (0,___WEBPACK_IMPORTED_MODULE_2__/* .getUtilOptions */ .Bv)(options);
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_1__.setItemBySession)(key, value, options, getEssentialItemType(isEssential));
}
function getSessionStorageItem(key, isEssential = false, options = {
  shouldParseJson: true
}) {
  options = (0,___WEBPACK_IMPORTED_MODULE_2__/* .getUtilOptions */ .Bv)(options);
  return (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_1__.getItemBySession)(key, options, getEssentialItemType(isEssential));
}
function removeSessionStorageItem(key) {
  (0,MMT_UI_storages_client_sessionStorage__WEBPACK_IMPORTED_MODULE_1__.removeItemBySession)(key);
}

/***/ }),

/***/ 59055:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": () => (/* binding */ getUtilOptions),
/* harmony export */   "Lp": () => (/* binding */ getHostName),
/* harmony export */   "Pj": () => (/* binding */ parsePriceToNumber)
/* harmony export */ });
/* unused harmony exports getDeviceModelType, disableEncrytionInWeb, isHostMakemytrip, loadGTM, TRIPMONEY_MMT_DOMAIN_NAMES */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);
/* harmony import */ var _tm_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69085);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const getDeviceModelType = () => {
  if ((0,_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.isOnServer)()) return null;

  if (window.mmt_android_bridge || window.app_bridge) {
    return _tm_types__WEBPACK_IMPORTED_MODULE_2__.DEVICE_MODEL_TYPE.APP;
  }

  return _tm_types__WEBPACK_IMPORTED_MODULE_2__.DEVICE_MODEL_TYPE.WEB;
};
function getHostName() {
  if ((0,_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.isOnServer)()) {
    return null;
  }

  if ( true && typeof window.getHostName === "undefined") {
    window.getHostName = () => {
      return window.location.hostname;
    };
  }

  return window?.getHostName?.();
}
function disableEncrytionInWeb() {
  return getDeviceModelType() === _tm_types__WEBPACK_IMPORTED_MODULE_2__.DEVICE_MODEL_TYPE.WEB && [_tm_types__WEBPACK_IMPORTED_MODULE_2__.HOST.MAKEMYTRIP, _tm_types__WEBPACK_IMPORTED_MODULE_2__.HOST.TRIPMONEY_MAKEMYTRIP].includes(getHostName() || "");
}
const isHostMakemytrip = () => {
  if (isOnServer()) return false;
  const url = new URL(window.location.href);
  return TRIPMONEY_MMT_DOMAIN_NAMES.includes(url.hostname);
};

const getGtmScript = gtmId => {
  return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer', '${gtmId}');
  `;
};

const loadGTM = () => {
  if (isHostMakemytrip() && true && !window?.dataLayer) {
    const script = document.createElement("script");
    script.innerHTML = getGtmScript("GTM-NWV3K7C");
    script.defer = true;
    document.head.appendChild(script);
  }
};
function getUtilOptions(options) {
  return disableEncrytionInWeb() ? _objectSpread(_objectSpread({}, options), {}, {
    isPiiData: false
  }) : options;
}
const TRIPMONEY_MMT_DOMAIN_NAMES = (/* unused pure expression or super */ null && (["tripmoney.makemytrip.com", "insurance.makemytrip.com", "www.makemytrip.com"]));
/**
 * Extracts numeric value from a price string and returns it as a number
 * @param priceString - Price string like "₹ 333", "$100.50", "€1,234.56", etc.
 * @returns The numeric value as a number (including decimals), or 0 if parsing fails
 *
 * @example
 * parsePriceToNumber("₹ 333") // returns 333.00
 * parsePriceToNumber("$100.50") // returns 100.50
 * parsePriceToNumber("€1,234.56") // returns 1234.56
 * parsePriceToNumber("invalid") // returns 0
 */

const parsePriceToNumber = priceString => {
  if (!priceString || typeof priceString !== "string") {
    return 0;
  } // Remove all non-digit characters except decimal points and commas
  // This handles various currency symbols (₹, $, €, £, etc.) and whitespace


  const cleanedString = priceString.replace(/[^\d.,]/g, "");

  if (!cleanedString) {
    return 0;
  } // Handle different decimal separators and thousand separators
  // Common formats: "1,234.56", "1.234,56", "1234.56", "1234"


  let numericString = cleanedString; // If there are multiple dots or commas, assume the last one is decimal separator

  const lastDotIndex = numericString.lastIndexOf(".");
  const lastCommaIndex = numericString.lastIndexOf(",");

  if (lastDotIndex > -1 && lastCommaIndex > -1) {
    // Both dot and comma present - the later one is decimal separator
    if (lastDotIndex > lastCommaIndex) {
      // Dot is decimal separator, remove commas
      numericString = numericString.replace(/,/g, "");
    } else {
      // Comma is decimal separator, replace with dot and remove other dots
      numericString = numericString.substring(0, lastCommaIndex).replace(/\./g, "") + "." + numericString.substring(lastCommaIndex + 1);
    }
  } else if (lastCommaIndex > -1 && numericString.indexOf(",") !== lastCommaIndex) {
    // Multiple commas - likely thousand separators, remove all
    numericString = numericString.replace(/,/g, "");
  } else if (lastDotIndex > -1 && numericString.indexOf(".") !== lastDotIndex) {
    // Multiple dots - likely thousand separators, remove all except last
    numericString = numericString.substring(0, lastDotIndex).replace(/\./g, "") + numericString.substring(lastDotIndex);
  } // Parse to float and return the full numeric value


  const numericValue = parseFloat(numericString);

  if (isNaN(numericValue)) {
    return 0;
  } // Return as double (floating-point number)


  return numericValue;
};

/***/ }),

/***/ 85129:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ })

}]);